import React from "react";
import { RiLockPasswordLine } from "react-icons/ri";

const ForgotPassword = ({
  forgotLoading,
  setForgotPasswordModal,
  handleForgotPassword,
  setEmail,
  email,
}) => {
  return (
    <div
      className="fixed inset-0 bg-foreground/60 flex justify-center items-center z-50 p-4 sm:p-6 font-sans"
      onClick={() => setForgotPasswordModal(false)}
    >
      <div
        className="bg-card p-5 sm:p-8 rounded-xl border border-border shadow-theme w-full max-w-lg relative max-h-[calc(100dvh-2rem)] overflow-y-auto custom-scrollbar"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="h-1.5 card-gradient-strip -m-5 sm:-m-8 mb-4 sm:mb-5 rounded-t-xl" />
        <h2 className="font-heading text-xl font-bold text-primary text-center tracking-tight mb-1">
          Forgot Your Password?
        </h2>
        <div className="flex justify-center my-5 sm:my-6">
          <span className="flex h-20 w-20 items-center justify-center rounded-xl bg-secondary">
            <RiLockPasswordLine size={44} className="text-primary" />
          </span>
        </div>

        <p className="text-center text-sm text-muted-foreground">
          Enter your email address to receive a password reset link.
        </p>
        <form onSubmit={handleForgotPassword}>
          <div className="mb-4 mt-5 sm:mt-6">
            <label className="bef-label">Email</label>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter Your Email Address"
              autoComplete="off"
              className="bef-input"
              required
            />
          </div>
          <button
            type="submit"
            disabled={forgotLoading}
            className={`bef-btn-primary w-full mt-3 transition-all duration-300 ${
              forgotLoading
                ? "!bg-primary !border-primary !text-white opacity-90 cursor-wait pointer-events-none"
                : ""
            }`}
          >
            {forgotLoading ? <div className="loader"></div> : "Send Reset Link"}
          </button>
        </form>
        <div
          className="flex items-center justify-center mt-3 cursor-pointer"
          onClick={() => setForgotPasswordModal(false)}
        >
          <p className="text-primary text-sm font-bold hover:text-accent hover:underline transition-colors">Back to Login</p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
